import { request } from ".";
import { Id } from "src/utils/types";

export type TrainingChecklistItem = {
  id: number | null;
  company_id: number;
  slug?: string;
  name: string;
  status: "Realizado" | "Pendente";
  last_performed_at: string | null;
};

export type TrainingChecklistResponse = {
  company_id: number;
  trainings: TrainingChecklistItem[];
};

export type TrainingChecklistPayload = {
  trainings: Array<Pick<TrainingChecklistItem, "slug" | "name" | "status" | "last_performed_at">>;
};

export const getTrainingChecklist = async (companyId: Id) => {
  const response = await request.get<TrainingChecklistResponse>(`/upsells/${companyId}/training-checklist`);

  return response.data;
};

export const updateTrainingChecklist = async (companyId: Id, payload: TrainingChecklistPayload) => {
  await request.put(`/upsells/${companyId}/training-checklist`, payload);
};

export type ComplianceIndicators = {
  company_id: number;
  coverage_percentage: number;
  monthly_average: number;
  yearly_total: number;
  lectures_count: number;
  dynamics_count: number;
  trainings_completed: number;
  updated_at: string | null;
  updated_by: number | null;
};

export type ComplianceIndicatorsPayload = Omit<ComplianceIndicators, "company_id" | "updated_at" | "updated_by">;

export const getComplianceIndicators = async (companyId: Id) => {
  const response = await request.get<ComplianceIndicators>(`/upsells/${companyId}/compliance-indicators`);

  return response.data;
};

export const updateComplianceIndicators = async (companyId: Id, payload: ComplianceIndicatorsPayload) => {
  await request.put(`/upsells/${companyId}/compliance-indicators`, payload);
};

export type BlockStatusMessage = {
  title?: string;
  description?: string;
};

export type BlockStatus = {
  company_id: number;
  is_blocked: boolean;
  block_type: "full" | "soft";
  restricted_actions: string[];
  status_message: BlockStatusMessage | null;
  internal_message: string | null;
  updated_by: number | null;
  updated_at: string | null;
};

export type BlockStatusPayload = {
  is_blocked: boolean;
  restricted_actions: string[];
  status_message: BlockStatusMessage | null;
  internal_message?: string | null;
};

export const getBlockStatus = async (companyId: Id) => {
  const response = await request.get<BlockStatus>(`/upsells/${companyId}/block-status`);

  return response.data;
};

export const updateBlockStatus = async (companyId: Id, payload: BlockStatusPayload) => {
  await request.patch(`/upsells/${companyId}/block-status`, payload);
};

export const getSoftBlockStatus = async (companyId: Id) => {
  const response = await request.get<BlockStatus>(`/upsells/${companyId}/soft-block`);

  return response.data;
};

export const updateSoftBlockStatus = async (companyId: Id, payload: BlockStatusPayload) => {
  await request.patch(`/upsells/${companyId}/soft-block`, payload);
};
